import { Bookings } from "../Bookings";
import { useOrgContext } from "../../context/OrgContext";

export function VenueBookings() {
  const { currentVenue } = useOrgContext();
  if (!currentVenue) return null;
  return <Bookings venueId={currentVenue.id} />;
}
